window.testThatErrorReportingStillWorks = ->
  setTimeout (-> throw new Error("Error reporting still works!")), 1000
